import { put, take } from 'redux-saga/effects';

import { actions } from '../actions/confirmModal';

export function* withConfirmation(
  payload: any,
  onConfirm: Function,
  onCancel?: Function,
) {
  yield put(actions.confirmModalShow(payload));

  const { type } = yield take([
    actions.confirmModalConfirm.toString(),
    actions.confirmModalCancel.toString(),
  ]);

  switch (type) {
    case actions.confirmModalConfirm.toString():
      yield* onConfirm();
      break;

    case actions.confirmModalCancel.toString():
      if (onCancel) {
        yield* onCancel();
      }
      break;

    default:
  }

  yield put(actions.confirmModalHide());
}
